import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { ESHOP_TEST_ID } from '@telialt/core-eshop/src/test/test-ids';

import { StartTextButton } from './GiftGroup.styles';

type Props = { onClick: () => void; className?: string };

export const OpenGiftDetailsModalButton: FC<Props> = ({ onClick, className }) => {
    const { t } = useTranslations();

    return (
        <StartTextButton onClick={onClick} className={className} data-test={ESHOP_TEST_ID.OPEN_GIFT_DETAILS_MODAL}>
            {t['eshop.product_page.gift_slider.item_details']}
        </StartTextButton>
    );
};
